<template>
  <wg-modal :width="'80%'" v-if="show" @closeModal="emitVariations">
    <div slot="header" class="com-anm22-app-text-xxl no-select" style="margin-bottom:10px;">
      {{ element.productName + ' - ' + $anm22.strLang(lang, 'Variations', 'Variazioni') }}
    </div>
    <div slot="body" class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6"  style="padding:0 5px;">
        <div class="wg-row" style="height:36px;flex-wrap:nowrap;align-items:center;">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Selected', 'Selezionate') }}
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row com-anm22-food-var-div no-select" style="margin-bottom:10px;">
          <div
              v-for="(v,index) in selected"
              :key="'var-'+index"
              class="label"
              @click="deleteVar(index)">
            <div class="com-anm22-app-text-l" style="text-align:center;">
              {{ v.sign + ' ' + $anm22.food_getVariationName(lang, v)  }}
            </div>
          </div>
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px;">
        <div class="wg-row" style="align-items:center;">
          <div class="wg-row no-select" style="flex-wrap:nowrap;align-items:center;justify-content:space-around;">
            <div
                :class="['com-anm22-food-var-button', signSelected === '+' ? 'selected' : '']"
                style="cursor:pointer;"
                @click="signSelected = '+';"
            >
              +
            </div>
            <div
                :class="['com-anm22-food-var-button', signSelected === '-' ? 'selected' : '']"
                style="cursor:pointer;"
                @click="signSelected = '-';"
            >
              -
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row com-anm22-food-var-div no-select">
            <div
                v-for="(v,index) in variations"
                :key="'var-select-'+index"
                class="label"
                @click="selectVar(v)"
            >
              <div class="com-anm22-app-text-l" style="text-align:center;">
                {{ $anm22.food_getVariationName(lang, v) }}
              </div>
              <div class="com-anm22-app-text-l" style="color:#999;text-align:center;">
                {{ v.price + '&euro;'}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </wg-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    show: Boolean,
    element: Object
  },
  data() {
    return {
      selected: this.element.variations.splice(0),
      signSelected: '+',
      custom: {
        text: '',
        price: 0
      }
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    product() {
      return this.$store.getters['foodProducts/get'](this.element.product);
    },
    category() {
      return this.$store.getters['foodCategories/get'](this.product.category);
    },
    variations() {
      return this.product.variations.concat(this.category.variations);
    }
  },
  methods: {
    emitVariations() {
      this.$emit('set-variations', this.selected);
    },
    selectVar: function(v) {
      const newVar = {
        sign: this.signSelected,
        ...v,
        listPrice: v.price
      };
      if(this.signSelected === '-') {
        newVar.listPrice = newVar.price = 0;
      }
      this.selected.push(newVar);
    },
    deleteVar: function(index) {
      this.selected.splice(index, 1);
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-width: 150px;
  width: 150px;
  height: 60px;
  border-radius: 5px;
  background-color: #fff;
  border: 2px solid #ddd;
  margin: 2px;
  cursor: pointer;
}
</style>
